export default __webpack_public_path__ + "static/deco_bg-f0d8dfb439c395c27a08b36c94e39585.svg";